import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';

/**
 * Only an outlet: the chrome belongs to the two layout routes below it, because the application and the
 * workspace around it are laid out by different hands. `RuntimeHostComponent` renders the organization's
 * published application — its chrome is the definition's. `WorkspaceShellComponent` frames the designer
 * and the administration — its chrome is the platform's. See `createAppRoutes`.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: `
    :host {
      display: block;
      height: 100%;
    }
  `,
})
export class AppComponent {
  constructor(iconRegistry: MatIconRegistry) {
    // Every `<mat-icon>` in the application and in the framework libraries names a Material Symbol,
    // not a ligature of the older font. Without this the icons render as their own names.
    iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }
}
